export default __webpack_public_path__ + "static/barfplan-blog-promo@3x-96ddf3870d1d3aaa30105b8635b958b9.png";